<div class="sidenav" [ngClass]="collapsed ? 'sidenav-collapsed' : ''">
  <!-- Main expanded navigation -->
  <div class="scrollwrap scrollwrap_delayed" *ngIf="collapsed">
    <ul class="sidenav-nav">
      <!-- Main menu items -->
      <ng-container *ngFor="let data of navData; index as idx">
        <li
          style="margin-left: 10px"
          [class.for-open-option]="data.menu_code === activeMenuCode"
          class="sidenav-nav-item"
        >
          <a
            *ngIf="isSynopsisCatalogueMenu(data)"
            class="sidenav-nav-link"
            style="width: 90%; background-color: transparent"
            [routerLink]="['/', synopsisRoute]"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="navigateSynopsis()"
            (keydown.enter)="navigateSynopsis()"
          >
            <div class="cls-div">
              <svg
                style="margin-right: 15px"
                class="sidenav-collapsed-icon-closed"
                tooltipPosition="right"
              >
                <use [attr.xlink:href]="getImageSrc(data.icon)" />
              </svg>
              <span class="sidenav-link-text" *ngIf="collapsed">
                {{ data.menu_name }}
              </span>
            </div>
          </a>

          <button
            *ngIf="
              !isSynopsisCatalogueMenu(data) &&
              data.items &&
              data.items.length > 1
            "
            (click)="showSubMenu(idx)"
            (keydown.enter)="showSubMenu(idx)"
            class="bg-transparent"
            style="width: 100%"
          >
            <!-- Divider line -->
            <!-- Main menu link with submenu toggle -->
            <button
              class="sidenav-nav-link"
              style="width: 90%; background-color: transparent"
              (click)="handleClick(data)"
              (keydown.enter)="handleClick(data)"
            >
              <div class="cls-div">
                <svg
                  style="margin-right: 15px"
                  class="sidenav-collapsed-icon-closed"
                  tooltipPosition="right"
                >
                  <use [attr.xlink:href]="getImageSrc(data.icon)" />
                </svg>
                <span class="sidenav-link-text" *ngIf="collapsed">
                  {{ data.menu_name }}
                </span>
              </div>
              <span class="sidenav-link-text"> </span>
            </button>
          </button>

          <!-- Single-submenu menu -->
          <a
            *ngIf="
              !isSynopsisCatalogueMenu(data) &&
              data.items &&
              data.items.length === 1
            "
            class="sidenav-nav-link"
            style="width: 90%; background-color: transparent"
            [routerLink]="[data.items[0].route_link]"
            routerLinkActive="active"
            (click)="subMenuClick(data.items[0])"
            (keydown.enter)="subMenuClick(data.items[0])"
          >
            <div class="cls-div">
              <svg
                style="margin-right: 15px"
                class="sidenav-collapsed-icon-closed"
                tooltipPosition="right"
              >
                <use [attr.xlink:href]="getImageSrc(data.icon)" />
              </svg>
              <span class="sidenav-link-text" *ngIf="collapsed">
                {{ data.menu_name }}
              </span>
            </div>
          </a>

          <!-- Main menu item without submenu -->
          <a
            class="sidenav-nav-link"
            *ngIf="!data.items || (data.items && data.items.length === 0)"
            [routerLink]="[data.route_link]"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="shrinkItems(data)"
            (keydown.enter)="shrinkItems(data)"
          >
            <i class="sidenav-link-icon" [class]="data.icon"></i>
            <span class="sidenav-link-text" @fadeInOut *ngIf="collapsed">{{
              data.menu_name
            }}</span>
          </a>
        </li>
        <div
          *ngIf="
            !isSynopsisCatalogueMenu(data) &&
            data.items &&
            data.items.length > 1
          "
          [@collapse]="{
            value: openedIndexSubMenu !== idx,
            params: { duration: this.openCloseDuration },
          }"
          class="sub-menu-option"
        >
          <app-sublevel-menu
            [data]="data"
            [collapsed]="collapsed"
            [multiple]="multiple"
            [expanded]="data?.expanded"
          ></app-sublevel-menu>
        </div>
      </ng-container>
    </ul>
  </div>

  <!-- Closed Menu navigation -->
  <div
    class="scrollwrap-closed scrollwrap_delayed closed-sidebar"
    *ngIf="!collapsed"
  >
    <ul class="sidenav-nav-closed">
      <li
        [class.active-sublevel-closed]="data.menu_code === activeMenuCode"
        class="sidenav-nav-item-closed closed-men-item"
        *ngFor="let data of navData"
      >
        <a
          *ngIf="isSynopsisCatalogueMenu(data)"
          class="sidenav-nav-link-closed"
          [title]="data.menu_name"
          [routerLink]="['/', synopsisRoute]"
          routerLinkActive="active-sublevel-closed"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="navigateSynopsis()"
          (keydown.enter)="navigateSynopsis()"
        >
          <div class="close-submenu-div">
            <svg class="sidenav-collapsed-icon-closed" tooltipPosition="right">
              <use [attr.xlink:href]="getImageSrc(data.icon)" />
            </svg>
          </div>
        </a>

        <button
          type="button"
          class="sidenav-nav-link-closed"
          [title]="data.menu_name"
          (click)="handleClick(data)"
          (keydown.enter)="handleClick(data)"
          *ngIf="
            !isSynopsisCatalogueMenu(data) &&
            data.items &&
            data.items.length > 1
          "
        >
          <div class="close-submenu-div">
            <svg class="sidenav-collapsed-icon-closed" tooltipPosition="right">
              <use [attr.xlink:href]="getImageSrc(data.icon)" />
            </svg>
          </div>
        </button>

        <!-- Single-submenu menu — navigate straight to the only child, no dropdown -->
        <a
          *ngIf="
            !isSynopsisCatalogueMenu(data) &&
            data.items &&
            data.items.length === 1
          "
          class="sidenav-nav-link-closed"
          [title]="data.menu_name"
          [routerLink]="[data.items[0].route_link]"
          routerLinkActive="active-sublevel-closed"
          (click)="subMenuClick(data.items[0])"
          (keydown.enter)="subMenuClick(data.items[0])"
        >
          <div class="close-submenu-div">
            <svg class="sidenav-collapsed-icon-closed" tooltipPosition="right">
              <use [attr.xlink:href]="getImageSrc(data.icon)" />
            </svg>
          </div>
        </a>

        <div
          *ngIf="
            data.expanded &&
            !isSynopsisCatalogueMenu(data) &&
            data.items &&
            data.items.length > 1
          "
          #closedSubmenu
          class="dropdown-menu closed-submenu show-dropdown"
        >
          <ul class="dropdown-content">
            <li *ngFor="let subItem of data.items">
              <a
                [routerLink]="[subItem.route_link]"
                routerLinkActive="active-sublevel-slide-container"
                (click)="subMenuClick(subItem)"
                >{{ subItem.sub_menu_name }}</a
              >
            </li>
          </ul>
        </div>
      </li>
    </ul>

    <!-- Profile — pinned to bottom, narrow sidenav -->
    <div class="sidenav-profile" *ngIf="!collapsed">
      <button
        type="button"
        class="sidenav-profile-avatar-btn"
        [title]="titleName"
        (click)="toggleProfileDropdown()"
        (keydown.enter)="toggleProfileDropdown()"
      >
        <span class="sidenav-profile-avatar">
          <img src="../../../../assets/img/common/avatar.png" alt="profile" />
        </span>
      </button>

      <div class="sidenav-profile-dropdown" *ngIf="showProfileDropdown">
        <button
          type="button"
          class="profile-dropdown-item profile-ico"
          (click)="navigateProfile()"
        >
          <svg class="icon" viewBox="0 0 20 20">
            <use xlink:href="assets/img/common/sprite.svg#profileIcon"></use>
          </svg>
          <span class="profile-label">Profile</span>
        </button>
        @if (showLogoutFlag) {
          <button
            type="button"
            class="profile-dropdown-item"
            (click)="logout()"
          >
            <svg class="icon" viewBox="0 0 18 18">
              <use xlink:href="assets/img/truck/sprite.svg#logout"></use>
            </svg>
            <span>Logout</span>
          </button>
        }
      </div>
    </div>
  </div>

  <!-- Profile — pinned to bottom, expanded sidenav -->
  <div class="sidenav-profile-expanded" *ngIf="collapsed">
    <button
      type="button"
      class="sidenav-profile-expanded-trigger"
      aria-haspopup="true"
      [attr.aria-expanded]="showProfileDropdown"
      (click)="toggleProfileDropdown()"
      (keydown.enter)="toggleProfileDropdown()"
    >
      <span class="sidenav-profile-avatar">
        <img src="../../../../assets/img/common/avatar.png" alt="profile" />
      </span>
      <span class="sidenav-profile-info">
        <span class="sidenav-profile-name">{{ titleName }}</span>
        <span class="sidenav-profile-role">{{ rolename }}</span>
      </span>
    </button>

    <div class="sidenav-profile-dropdown" *ngIf="showProfileDropdown">
      <button
        type="button"
        class="profile-dropdown-item"
        (click)="navigateProfile()"
      >
        <svg class="icon" viewBox="0 0 20 20">
          <use xlink:href="assets/img/common/sprite.svg#profileIcon"></use>
        </svg>
        <span>Profile</span>
      </button>
      @if (showLogoutFlag) {
        <button type="button" class="profile-dropdown-item" (click)="logout()">
          <svg class="icon" viewBox="0 0 18 18">
            <use xlink:href="assets/img/truck/sprite.svg#logout"></use>
          </svg>
          <span>Logout</span>
        </button>
      }
    </div>
  </div>
</div>

<p-toast></p-toast>
